import { ROUTER_PATHS } from '@constants/router';

export const DOCS_MENU_ITEMS = [
  { href: ROUTER_PATHS.FIRST_STEPS, messageId: 'core.header.docs.first-steps' },
  { href: ROUTER_PATHS.GLOSSARY, messageId: 'core.header.docs.glossary' },
  { href: ROUTER_PATHS.COLLECTIONS, messageId: 'core.header.docs.collections' },
  { href: ROUTER_PATHS.CHANGELOG, messageId: 'core.header.docs.changelog' },
  { href: ROUTER_PATHS.RATE_LIMIT, messageId: 'core.header.docs.rate-limit' },
];

export const DOCS_MENU_ITEMS_NO_COLLECTIONS = [
  { href: ROUTER_PATHS.GUIDES, messageId: 'core.header.docs.guides' },
  { href: ROUTER_PATHS.REFERENCES, messageId: 'core.header.docs.api-reference' },
  { href: ROUTER_PATHS.GLOSSARY, messageId: 'core.header.docs.glossary' },
  { href: ROUTER_PATHS.CHANGELOG, messageId: 'core.header.docs.changelog' },
];

export const EMBEDDABLES_MENU_ITEMS = [
  { href: ROUTER_PATHS.EMBEDDABLES, messageId: 'core.header.embeddables.resources' },
  { href: ROUTER_PATHS.EMBEDDABLES_DOCS, messageId: 'core.header.embeddables.docs' },
  { href: ROUTER_PATHS.EMBEDDABELS_CHANGELOG, messageId: 'core.header.docs.changelog' },
];

export const COMMUNITY_MENU_ITEMS = [
  { href: '/not-implemented', messageId: 'core.header.community.blog' },
  { href: '/not-implemented', messageId: 'core.header.community.forum' },
];

export const SUPPORT_MENU_ITEMS = [
  { href: ROUTER_PATHS.FAQ, messageId: 'core.header.support.faq' },
  { href: ROUTER_PATHS.API_STATUS, messageId: 'core.header.support.api-status' },
  { href: ROUTER_PATHS.TICKETS, messageId: 'core.header.support.cases' },
  { href: '/not-implemented', messageId: 'core.header.support.cases' },
];

export const SUPPORT_MENU_ITEMS_FAQ = [
  { href: ROUTER_PATHS.FAQ, messageId: 'core.header.support.faq' },
  { href: ROUTER_PATHS.API_STATUS, messageId: 'core.header.support.api-status' },
  { href: ROUTER_PATHS.TICKETS, messageId: 'core.header.support.cases' },
];

export const ACCOUNT_MENU_ITEMS = [
  { href: ROUTER_PATHS.DEVELOPER_HOME, messageId: 'core.header.actions.sign-in' },
  { href: ROUTER_PATHS.SIGN_UP, messageId: 'core.header.actions.sign-up' },
];

export const LEFT_HEADER_PORTAL_ID = 'left-header-portal-id';
export const RIGHT_HEADER_PORTAL_ID = 'right-header-portal-id';
export const LEFT_HEADER_PORTAL_ID_HASH = '#left-header-portal-id';
export const RIGHT_HEADER_PORTAL_ID_HASH = '#right-header-portal-id';
